import { CallStatus } from '@hc-frontend/core-types';

export default function StatusBadge({
  callStatus,
}: {
  callStatus: CallStatus;
}) {
  switch (callStatus) {
    case CallStatus.Enum.ON_CALL:
      return (
        <div
          className={`bg-[#ECFDF3] text-[#027A48] pl-[5px] pr-12-12 rounded-full flex items-center`}
        >
          <div className={`bg-[#027A48] w-[15px] h-[15px] rounded-full`}></div>
          <div className={`ml-8-8`}>On a call with</div>
        </div>
      );
    default:
      return (
        <div
          className={`bg-[#FEF3F2] text-[#B3261E] pl-[5px] pr-12-12 rounded-full flex items-center`}
        >
          <div className={`bg-[#B3261E] w-[15px] h-[15px] rounded-full`}></div>
          <div className={`ml-8-8`}>Call ended</div>
        </div>
      );
  }
}
